import { useEffect, useState } from 'react';
import { DropdownOptionsContext } from './DropdownContext';
import defaultDropdownOptions from '../../../../configs/tenant/default/dropdownsConfig.json';
import PropTypes from 'prop-types';
import { fetchBusStopAllocationData } from 'utils/dataFetchUtils';

export const DropdownOptionsProvider = ({ children }) => {
	const [defaultBusStopOptions, setDefaultBusStopOptions] = useState({});
	const [dropdownOptions, setDropdownOptions] = useState({});
	useEffect(() => {
		const getBusStopListData = async () => {
			try {
				const busStopListData = await fetchBusStopAllocationData();
				setDefaultBusStopOptions(busStopListData);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		getBusStopListData();
	}, []);

	useEffect(() => {
		setDropdownOptions({
			...defaultDropdownOptions,
			...defaultBusStopOptions,
		});
	}, [defaultBusStopOptions]);
	return (
		<DropdownOptionsContext.Provider
			value={{
				dropdownOptions,
				setDropdownOptions,
			}}>
			{children}
		</DropdownOptionsContext.Provider>
	);
};

DropdownOptionsProvider.propTypes = {
	children: PropTypes.object,
};
